// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zQJd","content":"styles_content__S0h5c","tableWrap":"styles_tableWrap__2PEhA"};